import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import useIsMobileView from './hooks/useIsMobileView';
const IsMobileViewContext = createContext(false);
export const IsMobileViewProvider = ({ children }) => {
    const isMobileView = useIsMobileView();
    return (_jsx(IsMobileViewContext.Provider, { value: isMobileView, children: children }));
};
export const useIsMobileViewContext = () => useContext(IsMobileViewContext);
//# sourceMappingURL=IsMobileViewContext.js.map